/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { api } from '../lib/api.js';
import { PB_URL } from '../lib/config.js';
import { playBlip } from '../lib/sound.js';
import * as store from '../lib/store.js';

export default {
  // Vanuit het welkomstscherm kun je hier meteen heen; dat scherm gaat dan dicht.
  requestFeature() { return this.setState({ dialog: 'feature', featureFilter: 'open', featureText: '', featureError: '', featureNote: '', featureSent: false, notifOpen: false, welcome: false }, this.fetchFeatures); },

  async fetchFeatures(silent) {
      if (!silent) this.setState({ featureLoading: true });
      try {
        const res = await api(`${PB_URL}/api/collections/paal_feature_requests/records?sort=-created&perPage=200`);
        if (!res.ok) throw new Error(res.status);
        const data = await res.json();
        const key = this.voteKey();
        const local = this.localVotes();
        const items = (data.items || []).map((r) => {
          let voters = (r.votedBy || '').split('\n').map((v) => v.trim()).filter(Boolean);
          let votes = typeof r.votes === 'number' ? r.votes : voters.length;
          // Votes the server hasn't stored yet (fields missing) still count in this browser.
          if (local[r.id] && key && voters.indexOf(key) < 0) { voters = voters.concat([key]); votes += 1; }
          return { id: r.id, text: r.text || '', author: r.author || '', authorId: r.authorId || '', created: r.created || '', updated: r.updated || r.created || '', votedBy: voters.join('\n'), votes, solved: !!r.solved, declined: !!r.declined };
        });
        // Als moderator krijg je een melding zodra iemand een nieuw ideetje instuurt.
        if (this.isMaintainer) {
          const fresh = items.filter((f) => f.authorId !== this.state.accountId);
          if (this.featureIds) {
            const nw = fresh.filter((f) => !this.featureIds[f.id]);
            if (nw.length) {
              playBlip();
              this.notify(nw.length === 1
                ? '💡 ' + (nw[0].author || 'iemand') + ' stuurde een nieuw ideetje in: “' + nw[0].text.slice(0, 70) + '”'
                : '💡 ' + nw.length + ' nieuwe ideetjes in de ideeënbus.');
            }
          }
          this.featureIds = {};
          fresh.forEach((f) => { this.featureIds[f.id] = true; });
        }
        // Hier sprong vroeger een venster op zodra jouw eigen ideetje was
        // doorgevoerd. Dat is er een uit de familie "kijk eens wat er nieuw is",
        // en die vensters zijn allemaal weg. Wat er met je ideetje gebeurd is,
        // staat gewoon in de ideeënbus onder Gedaan.
        this.setState({ featureList: items, featureLoading: false });
        // De streep zetten. Twee momenten, en die dekken alles:
        //
        // De eerste keer, want anders begin je met een bolletje waar elk ideetje in
        // zit dat er ooit ingegooid is. En elke keer dat de bus voor je open staat,
        // want dan kijk je er precies naar; komt er dan via de live-lijn een ideetje
        // binnen, dan zie je het gebeuren en hoeft er niets meer geteld te worden.
        if (!this.state.featuresSeen || this.state.dialog === 'feature') this.markFeaturesSeen(items);
      } catch (e) {
        this.setState({ featureLoading: false });
      }
    },

  /**
   * Hoeveel ideetjes er zijn bijgekomen sinds je voor het laatst keek.
   *
   * Je eigen ideetjes tellen niet mee: die ken je, je hebt ze net ingestuurd. Dat is
   * dezelfde regel die de melding voor de moderator aanhoudt, een paar regels hoger.
   *
   * Vergelijken op de stempel van de server en niet op een aantal. Een aantal gaat
   * omlaag zodra de moderator een ideetje weghaalt, en dan zou het volgende nieuwe
   * ideetje het oude aantal alleen maar herstellen: geen bolletje, terwijl er wel wat
   * nieuws staat.
   */
  nieuweIdeetjes() {
      const sinds = this.state.featuresSeen || '';
      if (!sinds) return 0;
      const ik = this.state.accountId || '';
      return (this.state.featureList || []).filter((f) => f.created > sinds && f.authorId !== ik).length;
    },

  /**
   * Alles wat er nu staat is gezien.
   *
   * De lijst komt binnen op -created, dus de eerste is de nieuwste; toch zoek ik het
   * maximum op in plaats van de eerste te pakken, zodat dit ook klopt als er ooit
   * anders gesorteerd wordt. Een lege bus krijgt '0': dat is niet leeg, dus de streep
   * bestaat, en het is kleiner dan elke echte stempel, dus het eerste ideetje dat
   * binnenkomt telt.
   */
  markFeaturesSeen(lijst) {
      const nieuwste = (lijst || []).reduce((m, f) => (f.created > m ? f.created : m), '') || '0';
      if (nieuwste === this.state.featuresSeen) return;
      store.set('gp_features_seen', nieuwste);
      this.setState({ featuresSeen: nieuwste });
    }
};
